import * as React from 'react'

const SvgStackedMoveIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.375 17.5H2.5c-.69 0-1.25-.56-1.25-1.25V6.875c0-.69.56-1.25 1.25-1.25h6.875c.69 0 1.25.56 1.25 1.25v9.375c0 .69-.56 1.25-1.25 1.25zM2.5 6.875v9.375h6.875V6.875H2.5zM16.25 3.75l-.881.881 1.506 1.619H13.75v-2.5c0-.69-.56-1.25-1.25-1.25H6.25v1.25h6.25v8.75h1.25v-5h3.125l-1.506 1.619.881.881 3.125-3.125L16.25 3.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgStackedMoveIcon
